import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_SIGN_FORM_FULL_ADDRESS_COLLECTION = defineFcm('petition_sign_form_full_address_collection')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				decision_maker_blocklist: {
					type: 'array',
					optional: true,
					shape: {
						type: 'object',
						shape: {
							id: { type: 'string' },
						},
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Sign Form',
		description:
			'Enables full address collection (including street address) from users when signing a petition. Users must be authenticated before signature data is captured. A petition must be local or national and have at least one non-blocked decision maker to qualify:\n\nex. "decision_maker_blocklist": [{"id": "123"}]\nex. "decision_maker_blocklist": [{"id": "123"}, {"id": "456"}]\n\nhttps://change.atlassian.net/browse/CHANGE-85492',
		template: {
			enabled: false,
			decision_maker_blocklist: [],
		},
		import: false,
	});
